jQuery(document).ready(function($) {   
    console.log("ssddsd")
    /*jQuery('.recommended-product-slider').slick({
      infinite:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
    });*/
    
    $(".announcement-slider").slick({
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        variableWidth: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: true,
        cssEase: "linear",
        responsive: [{
            breakpoint: 1400,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 1000,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1
            }
        }]
    });
    $('body').on('click', '.load-morewrap a', function(e) {
        e.preventDefault();
        var href = $(this).attr("href");
        if (!href) return;
        $.ajax({
            url: href,
            type: "GET",
            beforeSend: function() {
                $("#loader").show();
            },
            success: function(data) {
                var newContent = $(data).find("#loadmorenews").html();
                if (newContent) $("#loadmorenews").append(newContent);
                var newPagination = $(data).find(".load-morewrap").html();
                if (newPagination) {
                    $(".load-morewrap").html(newPagination);
                } else {
                    $(".load-morewrap").remove();
                }
            },
            error: function() {
                console.error("Failed to load more content.");
            },
            complete: function() {
                $("#loader").hide();
            }
        });
    });
    $("#key-ingredients").click(function() {
        $("body").toggleClass("sidebar-show");
    });
    $(".hamburger-nav-close").click(function() {
        $("body").removeClass("sidebar-show");
    });
    $(".add-to-cart-form").click(function() {
        $("body").addClass("changeCursor");
    });
    $(".drawer__close").click(function() {
        $("body").removeClass("changeCursor");
    });
    /*$("#cart-icon-bubble").click(function() {
        $("body").addClass("side-cart-bar-show");
    });*/
    //detectDeviceAndBrowser();
});

/* Hanging widget function */
document.addEventListener('DOMContentLoaded', function() {
  const widget = document.querySelector('.hanging-widget');

  // Function to check the current URL and show/hide the widget
  function checkPage() {
    if (widget) { // Check if widget exists before doing anything
      if (window.location.pathname === '/products/brightening-hyper-c-serum') {
        // Show the widget on the specific product page
        widget.style.display = 'flex';

        // Add event listener to the widget to redirect to the cart page
        widget.addEventListener('click', function() {
          window.location.href = "/cart"; // Redirect to the cart page
        });
      } else if (window.location.pathname === '/cart') {
        // Hide the widget on the cart page
        widget.style.display = 'none';
      } else {
        // Hide the widget on all other pages
        widget.style.display = 'none';
      }
    }
  }

  // Run the function to check the page initially
  checkPage();

  // Optional: In case the cart is loaded via AJAX or without reloading the page,
  // you can monitor URL changes using the History API or hash change event to hide the widget.
  window.addEventListener('popstate', checkPage); // This listens to back/forward navigation

  const intervalId = setInterval(function () {
    const hiddenElements = document.querySelectorAll('.delivery-hidden');

    // If no elements have the class anymore, stop the interval
    if (hiddenElements.length === 0) {
      console.log("All 'delivery-hidden' classes removed. Stopping interval.");
      clearInterval(intervalId);
      return;
    } 
    hiddenElements.forEach(function (el) {
      el.classList.remove('delivery-hidden'); // optional if you want to remove the class
      el.remove(); // removes the element from the DOM
    });
  }, 500); // Check every 500ms (adjust as needed)
});



// $(document).ready(function() {
//   setTimeout(function() {
//     // Add CSS to the desired element
//     $('.apple-pay-button').css( 'border-radius','10px !important');    
//   }, 500);
// });


jQuery(document).ready(function ($) {
    $('.view-result').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior if it's a link

        $('html, body').animate({
            scrollTop: $('#custom-image-section').offset().top
        }, 800); // 800ms for smooth effect
    });
});


